import adminsStore from './adminsStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.admins) {
      store.registerModule(['base', 'admins'], adminsStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'admins']);
  },
};
